export default __webpack_public_path__ + "static/media/Valli Jewellers Logo 1.f08345e8.PNG";